module.exports = __webpack_public_path__ + "img/bitcoin.142e1c9e.png";